import axiosInstance from "../../config/axio.config"; 
const requests = '/requests';


export const requestsByTypeFn = async (reqBody) => {
    try {
      const response =  await axiosInstance.get(requests+'/type', { params: reqBody })
      return response?.data;
    } catch ({ error }) {
      throw new Error(error?.message)
    }
};
